import { MessageBar, MessageBarBody, MessageBarActions, Button } from '@fluentui/react-components';
import React from 'react';
import { getCurrentAppVersion } from '../../../utils/ApiProvider';
import { FeatureFlagConsumer } from '../../../utils/featureFlags/FeatureFlagContext';

const OutdatedUiBanner = (): JSX.Element => {
  const currentAppVersion = React.useMemo(() => {
    return getCurrentAppVersion();
  }, []);

  const refreshPage = (): void => {
    window.location.reload();
  };

  return (
    <FeatureFlagConsumer>
      {({ currentUiVersion }) => (
        <>
          {currentAppVersion !== currentUiVersion &&
            currentUiVersion?.length > 0 &&
            currentAppVersion !== 'DevBuild' && (
              <MessageBar intent="warning" layout="multiline">
                <MessageBarBody>
                  You are using an outdated version of this web page. Click the refresh button to
                  reload the page. If this message persists, clear your browser&apos;s cache.
                </MessageBarBody>
                <MessageBarActions
                  containerAction={<Button onClick={refreshPage}>Refresh</Button>}
                />
              </MessageBar>
            )}
        </>
      )}
    </FeatureFlagConsumer>
  );
};

export default OutdatedUiBanner;
